import { extend } from 'flarum/common/extend';
import FlagPostModal from 'flarum/flags/components/FlagPostModal';
import CustomFlagReason from '../../common/models/CustomFlagReason';

/**
 * 举报
 */
export default function flagContent() {
  app.store.models['custom-flag-reasons'] = CustomFlagReason;

  extend(FlagPostModal.prototype, 'oninit', function() {
    console.log('[自定义举报] 初始化举报对话框');
    this.customReasons = [];

    // 确保在加载原因之前设置loading状态
    this.loadingCustomReasons = true;

    app.store.find('custom-flag-reasons')
      .then(reasons => {
        console.log('[自定义举报] 已加载原因列表:', reasons);
        if (Array.isArray(reasons)) {
          this.customReasons = reasons.filter(reason => reason.isActive());
          console.log('[自定义举报] 活跃的原因:', this.customReasons);
        } else {
          console.error('[自定义举报] 加载的原因不是数组:', reasons);
        }
      })
      .catch(error => {
        console.error('[自定义举报] 加载原因时出错:', error);
      })
      .finally(() => {
        this.loadingCustomReasons = false;
        m.redraw();
      });
  });

  extend(FlagPostModal.prototype, 'view', function(vnode) {
    if (this.loadingCustomReasons) {
      console.log('[自定义举报] 正在加载原因列表...');
      return;
    }

    console.log('[自定义举报] 渲染视图, 自定义原因:', this.customReasons);
    if (!this.customReasons || !this.customReasons.length) {
      console.log('[自定义举报] 没有可用的自定义原因');
      return;
    }

    // 打印完整的vnode结构以便调试
    console.log('[自定义举报] 完整的vnode结构:', vnode);

    // 递归查找Form-group
    const findFormGroup = (node) => {
      if (!node) return null;

      // 检查当前节点
      if (node.attrs?.className?.includes('Form-group')) {
        return node;
      }

      // 检查子节点
      if (Array.isArray(node.children)) {
        for (let child of node.children) {
          const result = findFormGroup(child);
          if (result) return result;
        }
      }

      return null;
    };

    // 查找包含选项的Form-group
    const formGroup = findFormGroup(vnode);
    if (!formGroup) {
      console.log('[自定义举报] 未找到Form-group');
      return;
    }

    // 查找选项容器div
    const optionsDiv = formGroup.children?.find(child => child.tag === 'div');
    if (!optionsDiv) {
      console.log('[自定义举报] 未找到选项容器div');
      return;
    }

    console.log('[自定义举报] 找到选项容器:', optionsDiv);

    // 查找"其他"选项的位置
    const labels = optionsDiv.children;
    if (!labels || !labels.length) {
      console.log('[自定义举报] 未找到选项列表');
      return;
    }

    const otherIndex = labels.findIndex(node => {
      if (!node || !node.children || !node.children[0]) return false;
      const input = node.children[0];
      return input.attrs?.value === 'other';
    });

    console.log('[自定义举报] "其他"选项索引:', otherIndex);

    if (otherIndex === -1) {
      console.log('[自定义举报] 未找到"其他"选项');
      return;
    }

    // 插入自定义原因
    this.customReasons.forEach(reason => {
      const customReason = (
        <label className="checkbox">
          <input
            type="radio"
            name="reason"
            checked={this.reason() === reason.name()}
            value={reason.name()}
            onclick={() => {
              this.reason(reason.name());
              this.reasonDetail(reason.description());
              // 保存自定义原因ID
              this.customFlagReasonId = reason.id();
            }}
          />
          <strong>{reason.name()}</strong>
          {reason.description() && (
            <span> {reason.description()}</span>
          )}
        </label>
      );

      // 在"其他"选项之前插入
      labels.splice(otherIndex, 0, customReason);
    });
  });

  extend(FlagPostModal.prototype, 'data', function(data) {
    const reasonPrefix = '';
    if (this.reason()?.startsWith(reasonPrefix)) {
      // 使用保存的自定义原因ID
      const customReasonId = this.customFlagReasonId;
      if (customReasonId) {
        console.log('[自定义举报] 发送举报数据，自定义原因ID:', customReasonId);
        data.relationships = data.relationships || {};
        data.relationships.customFlagReason = {
          data: {
            type: 'custom-flag-reasons',
            id: customReasonId
          }
        };
      }
    }
    return data;
  });
}
